"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchHubSettings = fetchHubSettings;
exports.fetchHubSettingsIfNeeded = fetchHubSettingsIfNeeded;
exports.updateHubSettings = updateHubSettings;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var HubSettingsApiClient = _interopRequireWildcard(require("lead-flows-ui/api/HubSettingsApiClient"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _HubSettings = require("lead-flows-ui/selectors/HubSettings");

function requestHubSettings() {
  return {
    type: _ActionTypes.REQUEST_HUB_SETTINGS
  };
}

function receiveHubSettings(settings) {
  return {
    type: _ActionTypes.REQUEST_HUB_SETTINGS_SUCCESS,
    settings: settings
  };
}

function handleReceiveHubSettingsError(message) {
  return {
    type: _ActionTypes.REQUEST_HUB_SETTINGS_ERROR,
    message: message
  };
}

function requestUpdateHubSettings(settings) {
  return {
    type: _ActionTypes.UPDATE_HUB_SETTINGS,
    settings: settings
  };
}

function updateHubSettingsSuccess(setting, value) {
  return {
    type: _ActionTypes.UPDATE_HUB_SETTINGS_SUCCESS,
    setting: setting,
    value: value
  };
}

function handleUpdateHubSettingsError(message) {
  return {
    type: _ActionTypes.UPDATE_HUB_SETTINGS_ERROR,
    message: message
  };
}

function fetchHubSettings() {
  return function (dispatch) {
    dispatch(requestHubSettings());
    HubSettingsApiClient.getHubSettings().then(function (response) {
      dispatch(receiveHubSettings(response.settings));
    }, function (error) {
      var message = error ? error.message : '';
      dispatch(handleReceiveHubSettingsError(message));
    }).done();
  };
}

function fetchHubSettingsIfNeeded() {
  return function (dispatch, getState) {
    var requestState = (0, _HubSettings.getFetchRequestState)(getState());

    if (!requestState.shouldBeRequested()) {
      return;
    }

    dispatch(fetchHubSettings());
  };
}

function updateHubSettings(key, value) {
  return function (dispatch) {
    dispatch(requestUpdateHubSettings((0, _defineProperty2.default)({}, key, value)));
    HubSettingsApiClient.updateHubSettings(key, value).then(function () {
      dispatch(updateHubSettingsSuccess(key, value));
    }, function (error) {
      var message = error ? error.message : '';
      dispatch(handleUpdateHubSettingsError(message));
    }).done();
  };
}